import { Component, Input, OnInit } from '@angular/core';
import { UtilService } from '@app/services/util.service';
import { APP_ROUTES as ROUTES } from '@app/app.routes';
import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { environment } from '@environment';

@Component({
  selector: 'layout-footer-base',
  templateUrl: './footer-base.component.html',
  styleUrls: ['./footer-base.component.scss'],
})
export class FooterBaseComponent implements OnInit {
  @Input() currentRoute: string;

  public CONST = CONST;
  // public environment = environment;
  public BBVA_ROUTES = ROUTES;
  constructor(private _utilService: UtilService) {}

  ngOnInit(): void {}

  public onGoToPrivacyPolicy() {
    this._utilService.onOpenLink(environment.privacy_policy_url);
  }

  public onGoToTermsAndConditions() {
    this._utilService.onOpenLink(environment.terms_and_conditions_enduser_policy_url);
  }

  public onGoToCollectionPolicy() {
    this._utilService.onOpenLink(CONST.BBVA_PDF_COLLECTION_POLICY);
  }

  public onGoToFaqs() {
    this._utilService.onOpenLink('https://bbva-bnpl-pe-landing-portal-alpha.moprestamo.com/#faqs');
  }
}
